import { Flex } from "antd";
import React, { useEffect, useRef } from "react";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { CRUISE_CATEGORY } from "../../../utils/helpers";
import Legends from "../v2/Legends";

dayjs.extend(customParseFormat);

const PromoTagSvg = () => (
  <svg width="100%" viewBox="0 0 83 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.4294 1.18258C17.9097 1.14956 17.3941 1.32707 16.9964 1.67039C16.5986 2.01403 16.3513 2.49534 16.3084 3.01411C16.2656 3.53288 16.4305 4.04826 16.7664 4.45254C17.1024 4.85649 17.5819 5.11625 18.0999 5.16899C19.1067 5.27122 20.1134 5.37374 21.1202 5.47644C28.962 6.27648 36.8029 7.08801 44.6467 7.86464C54.9286 8.88267 65.2128 9.8718 75.4962 10.8715C76.5033 10.9694 77.5105 11.0674 78.5176 11.1656C79.3095 11.2429 80.0952 11.0011 80.7022 10.4866C81.3092 9.97242 81.6879 9.22763 81.7545 8.42287C81.821 7.61811 81.5697 6.82126 81.0553 6.21442C80.541 5.60719 79.8057 5.23969 79.0117 5.18597C78.0022 5.11746 76.9926 5.0488 75.9831 4.98004C65.6751 4.27799 55.368 3.56536 45.0585 2.88163C37.1937 2.36002 29.3259 1.87332 21.4591 1.37512C20.4492 1.31116 19.4393 1.24701 18.4294 1.18258Z" fill="url(#promo_paint0)"/>
    <g clipPath="url(#promo_clip0)">
      <rect x="12.1953" y="7.87402" width="70" height="18" rx="4" transform="rotate(-2.3565 12.1953 7.87402)" fill="url(#promo_paint1)"/>
      <g filter="url(#promo_filter0)">
        <circle cx="47.9613" cy="37.9289" r="24.5" transform="rotate(-2.3565 47.9613 37.9289)" fill="url(#promo_paint2)" fillOpacity="0.6"/>
      </g>
      <g filter="url(#promo_filter1)">
        <circle cx="31.4255" cy="13.0875" r="20" transform="rotate(-2.3565 31.4255 13.0875)" fill="url(#promo_paint3)" fillOpacity="0.5"/>
      </g>
    </g>
    <g clipPath="url(#promo_clip1)">
      <path d="M17.617 10.7796C16.1807 9.34075 14.939 8.05076 14.8557 6.02816C14.8084 4.87774 14.9916 3.75267 14.9932 3.74169C15.0277 3.53397 14.9671 3.322 14.8274 3.16449C14.6884 3.00691 14.4854 2.92032 14.2753 2.92896C13.0935 2.9776 9.75603 3.99134 9.91599 7.87834C10.0182 10.3626 9.54834 11.195 9.34031 11.418C9.22324 11.5444 9.06306 11.6193 8.92995 11.605C8.2866 11.624 8.1273 10.7083 8.12177 10.6737C8.08608 10.4375 7.93162 10.2355 7.71246 10.1393C7.49328 10.0418 7.2421 10.0637 7.04201 10.1976C4.38627 11.9744 2.87842 14.9389 3.00968 18.1283C3.21566 23.1337 7.45763 27.0851 12.463 26.8791C17.4684 26.6731 21.3714 22.3865 21.1654 17.3811C21.0348 14.2068 19.2186 12.3859 17.617 10.7796Z" fill="url(#promo_paint4)"/>
    </g>
    <defs>
      <filter id="promo_filter0" x="19.4609" y="9.42871" width="57.0005" height="57.0005" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix"/>
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
        <feGaussianBlur stdDeviation="2" result="effect1_foregroundBlur"/>
      </filter>
      <filter id="promo_filter1" x="7.42529" y="-10.9126" width="48.0005" height="48.0005" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix"/>
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
        <feGaussianBlur stdDeviation="2" result="effect1_foregroundBlur"/>
      </filter>
      <linearGradient id="promo_paint0" x1="19.7244" y1="3.17416" x2="78.0889" y2="7.89152" gradientUnits="userSpaceOnUse">
        <stop stopColor="#71F2DD" stopOpacity="0.4"/>
        <stop offset="1" stopColor="#DEE746"/>
      </linearGradient>
      <linearGradient id="promo_paint1" x1="10.8137" y1="15.2858" x2="83.0629" y2="12.8839" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FA9D12"/>
        <stop offset="1" stopColor="#FFB61F"/>
      </linearGradient>
      <linearGradient id="promo_paint2" x1="64.4613" y1="24.4289" x2="26.4613" y2="24.9289" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FF7E0C"/>
        <stop offset="1" stopColor="#DA9456"/>
      </linearGradient>
      <linearGradient id="promo_paint3" x1="38.9255" y1="2.0875" x2="12.9255" y2="22.5875" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FEC625"/>
        <stop offset="1" stopColor="#FB9013"/>
      </linearGradient>
      <linearGradient id="promo_paint4" x1="12.463" y1="26.8791" x2="11.4822" y2="3.04391" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FC416C"/>
        <stop offset="1" stopColor="#FF6200"/>
      </linearGradient>
      <clipPath id="promo_clip0">
        <rect x="12.1953" y="7.87402" width="70" height="18" rx="4" transform="rotate(-2.3565 12.1953 7.87402)" fill="white"/>
      </clipPath>
      <clipPath id="promo_clip1">
        <rect width="24" height="24" fill="white" transform="translate(0 3.37158) rotate(-2.3565)"/>
      </clipPath>
    </defs>
  </svg>
);

const TourDateSelectorV3 = (props: {
  dates: any[];
  selectedDate: string;
  selectedTourCode: any;
  selectTour: Function;
  category: string;
  isNew?: boolean;
  isLoading?: boolean;
  open?: boolean;
}) => {
  const { dates, selectedDate, selectedTourCode, selectTour, category, isLoading, open } = props;
  const isCruise = category === CRUISE_CATEGORY;
  const hasAnyGD = !isCruise && dates.some(t => t.type === "guaranteed");
  const scrollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // `open` is only meaningful for drawer usage (BookingFormV3) — skip only
    // when a drawer explicitly says it's closed. Inline usage (ShowPage) never
    // passes `open`, so it always scrolls the selected/resolved date into view.
    if (open === false || !scrollRef.current) return;
    const idx = dates.findIndex(t =>
      selectedDate ? (t.date === selectedDate && t.code === selectedTourCode) : t.code === selectedTourCode
    );
    const el = scrollRef.current.children[idx] as HTMLElement | undefined;
    if (el) el.scrollIntoView({ behavior: "auto", inline: "start", block: "nearest" });
  }, [open, selectedTourCode, selectedDate, dates.length]);

  return (
    <Flex gap={15} vertical className="tour-date-selector v3">
      {/* Native CSS scroll-snap row — no react-slick (avoids fractional-slidesToShow ghost-scroll) */}
      <div className={`wrapper${isLoading ? " is-loading" : ""}`} ref={scrollRef}>
        {dates.map((tour: { date: string; code: string; type: string; price: string; indicator: string; promoTag?: string }) => {
            const tourDate = dayjs(tour.date, "DD/MM/YYYY").toDate();
            const tourYear = tourDate.getFullYear();
            const tourDateFormatted = dayjs(tourDate).format("DD MMM");
            const selected = selectedDate
              ? selectedDate === tour.date && selectedTourCode === tour.code
              : selectedTourCode === tour.code;

            return (
              <div key={tour.code} className="tour-date-box-wrapper" onClick={() => selectTour(tour)}>
                {hasAnyGD && (
                  <div
                    className="tour-date-box_gd-badge"
                    style={tour.type !== "guaranteed" ? { visibility: "hidden" } : undefined}
                  >
                    Guaranteed Departure
                  </div>
                )}
                <div className={`tour-date-box ${!isCruise ? tour.type : ""} ${selected ? "selected" : ""}`}>
                  <Flex justify="space-between" align="center" vertical gap={8}>
                    <div className="tour-date-box_date">
                      <span>{tourYear}</span>
                      <b>{tourDateFormatted}</b>
                    </div>
                    <div>
                      <span>From</span>
                      <div className="tour-date-box_price">{tour.price}</div>
                    </div>
                  </Flex>
                </div>
                {tour.promoTag && (
                  <div className="tour-date-box_promo-tag">
                    <PromoTagSvg />
                    <span className="tour-date-box_promo-label">{tour.promoTag}</span>
                  </div>
                )}
              </div>
            );
          })}
      </div>

      {!isCruise && <Legends />}
    </Flex>
  );
};

export default TourDateSelectorV3;
